import $ from 'jquery';

$(document).ready(function () {
    // Large Hero swap slides
    if ($(".slide-wrapper .slide").length > 1) {
        setInterval(() => {
            $(".slide-wrapper .slide.active")
                .removeClass("active")
                .nextOrFirst(".slide")
                .addClass("active");
        }, 4000);
    }
});

$.fn.nextOrFirst = function (selector) {
    var next = this.next(selector);
    return (next.length) ? next : this.prevAll(selector).last();
};